module.exports = __webpack_public_path__ + "bag-97af1e5875bba7f029d811ba65e9d99b.png";